

<!-- ------------------Page Heading End------------- -->
<!-- ------------------Video Section End------------- -->
<!-- 
<section >
  
    <video width="100%" controls autoplay="true">
     <source src="assets/images/video.mp4" type="video/mp4">
     <source src="assets/images/video.ogg" type="video/ogg">
   </video>
   
   
   </section> -->

<!-- -------------------------Video Section Start----------------- -->

<!-- -------------------------Intro Section Start----------------- -->

<section class="ab-intro" id="abt_intro" #abIntro>
  <div class="ab-intro__deco" aria-hidden="true">
    <span class="ab-intro__blob ab-intro__blob--1"></span>
    <span class="ab-intro__blob ab-intro__blob--2"></span>
    <span class="ab-intro__dots ab-intro__dots--1"></span>
    <span class="ab-intro__dots ab-intro__dots--2"></span>
    <span class="ab-intro__spark" style="--sx: 8%; --sy: 26%; --sd: 0s"></span>
    <span class="ab-intro__spark" style="--sx: 92%; --sy: 16%; --sd: 1.3s"></span>
    <span class="ab-intro__spark" style="--sx: 70%; --sy: 84%; --sd: 0.7s"></span>
  </div>

  <div class="container ab-intro__inner">
    <div class="ab-intro__grid">
      <!-- ---------- left ---------- -->
      <div class="ab-intro__copy">
        <span class="ab-intro__eyebrow">About Us<i></i></span>

        <h2 class="ab-intro__title">
          Building Technology.<br />
          Empowering <span class="ab-intro__title-grad">Businesses.</span>
        </h2>
        <span class="ab-intro__rule" aria-hidden="true"></span>

        <p class="ab-intro__text">
          At ResilienceSoft, we're a team of innovators and problem-solvers
          passionate about harnessing technology to drive business growth and
          success. With over a decade of experience in software development and
          web design, we've established ourselves as a trusted partner for
          businesses seeking cutting-edge solutions.
        </p>

        <a class="ab-intro__cta" routerLink="/contact-us">
          Let's Build the Future
          <span class="ab-intro__cta-arrow" aria-hidden="true">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14M13 6l6 6-6 6" /></svg>
          </span>
        </a>
      </div>

      <!-- ---------- right ---------- -->
      <div class="ab-intro__visual">
        <span class="ab-intro__glow" aria-hidden="true"></span>
        <span class="ab-intro__orbit" aria-hidden="true"></span>

        <figure class="ab-intro__shot">
          <img
            loading="lazy"
            src="https://images.prismic.io/kurmishadi/38fd26f5-cef4-47c4-9ca7-dd8d73ab2730__%281%29.png?auto=compress,format"
            alt="ResilienceSoft team at work"
          />
        </figure>

        <span
          class="ab-float"
          *ngFor="let f of abFloats; let i = index"
          [attr.data-pos]="f.pos"
          [style.--i]="i"
        >
          <span class="ab-float__ico" [innerHTML]="f.icon"></span>
          {{ f.label }}
        </span>
      </div>
    </div>

    <!-- ---------- statistics ---------- -->
    <div class="ab-stats">
      <div class="ab-stat" style="--i: 0">
        <span class="ab-stat__ico">
          <img loading="lazy" class="counter_icon" src="assets/images/served.webp" alt="served" />
        </span>
        <span class="ab-stat__num">
          <span class="counter"><app-counting-number [targetValue]="2012"></app-counting-number></span>
        </span>
        <span class="ab-stat__label">The Company was Established.</span>
        <span class="ab-stat__rule" aria-hidden="true"></span>
      </div>

      <div class="ab-stat" style="--i: 1">
        <span class="ab-stat__ico">
          <img loading="lazy" class="counter_icon" src="assets/images/projects.webp" alt="projects" />
        </span>
        <span class="ab-stat__num">
          <span class="counter"><app-counting-number [targetValue]="500"></app-counting-number></span
          ><span class="counter_plus">+</span>
        </span>
        <span class="ab-stat__label">Internet Software Products for Market audience</span>
        <span class="ab-stat__rule" aria-hidden="true"></span>
      </div>

      <div class="ab-stat" style="--i: 2">
        <span class="ab-stat__ico">
          <img loading="lazy" class="counter_icon" src="assets/images/experts.webp" alt="experts" />
        </span>
        <span class="ab-stat__num">
          <span class="counter"><app-counting-number [targetValue]="250"></app-counting-number></span
          ><span class="counter_plus">+</span>
        </span>
        <span class="ab-stat__label">Customers</span>
        <span class="ab-stat__rule" aria-hidden="true"></span>
      </div>

      <div class="ab-stat" style="--i: 3">
        <span class="ab-stat__ico">
          <img loading="lazy" class="counter_icon" src="assets/images/groth.webp" alt="groth" />
        </span>
        <span class="ab-stat__num">
          <span class="counter"><app-counting-number [targetValue]="20"></app-counting-number></span
          ><span class="counter_plus">+</span>
        </span>
        <span class="ab-stat__label">Business partners</span>
        <span class="ab-stat__rule" aria-hidden="true"></span>
      </div>
    </div>

    <!-- ---------- story ---------- -->
    <div class="ab-story">
      <span class="ab-story__mark" aria-hidden="true">
        <svg viewBox="0 0 64 64" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
          <path d="M6 56h52" /><path d="M14 56V26l10-7 10 7v30" /><path d="M34 56V34l10-6 10 6v22" />
          <path d="M19 32h4M19 39h4M19 46h4M40 40h4M40 47h4" />
        </svg>
      </span>

      <p class="ab-story__text">
        At ResilienceSoft, we're a team of innovators and problem-solvers
        passionate about harnessing technology to drive business growth and
        success. With over a decade of experience in software development and
        web design, we've established ourselves as a trusted partner for
        businesses seeking cutting-edge solutions. Our journey began with a
        simple yet powerful idea: to empower organizations to reach their full
        potential through technology. Today, we're proud to have worked with
        numerous clients across various industries, delivering tailored
        solutions that meet
      </p>

      <span class="ab-story__rocket" aria-hidden="true">
        <span class="ab-story__trail"></span>
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">
          <path d="M4.5 16.5c-1.5 1.26-2 5-2 5s3.74-.5 5-2c.71-.84.7-2.13-.09-2.91a2.18 2.18 0 0 0-2.91-.09z" />
          <path d="m12 15-3-3a22 22 0 0 1 2-3.95A12.88 12.88 0 0 1 22 2c0 2.72-.78 7.5-6 11a22.35 22.35 0 0 1-4 2z" />
          <path d="M9 12H4s.55-3.03 2-4c1.62-1.08 5 0 5 0" />
          <path d="M12 15v5s3.03-.55 4-2c1.08-1.62 0-5 0-5" />
        </svg>
      </span>
    </div>
  </div>
</section>

<!-- -------------------------Strength Start----------------- -->
<!-- <section id="abt_intro">
  <div class="container">
    <div class="intro_holder our-strengths">
      <div class="white  text-center">

        <div>
          <div class="row">
            <div class="col-5">
              <div class="imgage">
                <img src="assets/images/our_strength.png" />
              </div>
            </div>
            <div class="col-7 pt-5">
              <h2>Our Strengths</h2>
              <div class="strenghts">
                <span class="circle_red"></span>
                <p class="fs-5">
                  Experienced team of software development professionals
                </p>
              </div>
              <div class="strenghts">
                <span class="circle_red"></span>
                <p class="fs-5">
                  Custom programming skills in .NET, XML, and more
                </p>
              </div>
              <div class="strenghts">
                <span class="circle_red"></span>
                <p class="fs-5">
                  Consistent delivery of high-quality solutions
                </p>
              </div>
              <div class="strenghts">
                <span class="circle_red"></span>
                <p class="fs-5">
                  Empowering skilled personnel to drive innovation
                </p>
              </div>
              <div class="strenghts">
                <span class="circle_red"></span>
                <p class="fs-5">
                  Transparency and reliability in our work culture and
                  procedures
                </p>
              </div>
              <div class="strenghts">
                <span class="circle_red"></span>
                <p class="fs-5">
                  Agile methodology to adapt to changing requirements
                </p>
              </div>
            </div> -->
<!-- <div class="strength col-lg-3">
              <span
                >Experienced team of software development professionals</span
              >
            </div>
            <div class="strength col-lg-3">
              <span>Custom programming skills in .NET, XML, and more</span>
            </div>
            <div class="strength col-lg-3">
              <span>Consistent delivery of high-quality solutions</span>
            </div>
            <div class="strength col-lg-3">
              <span>Empowering skilled personnel to drive innovation</span>
            </div>
            <div class="strength col-lg-3">
              <span>
                Transparency and reliability in our work culture and procedures
              </span>
            </div>
            <div class="strength col-lg-3">
              <span>Agile methodology to adapt to changing requirements</span>
            </div>
            <div class="strength col-lg-3">
              <span>Continuous learning and improvement approach</span>
            </div> -->
<!-- </div>
        </div>
      </div>
    </div>
  </div>
</section> -->

<app-global-presence></app-global-presence>

<app-strength></app-strength>

<!-- <section class="mt-5 pt-5">
  <div class="container">
    <div class="row">
      <div class="strength_image col-lg-6 col-md-6">
        <img src="assets/images/ourvision.png" />
      </div>
      <div class="strength_image col-lg-6 col-md-6">
        <img src="assets/images/ourmission.png" />
      </div>
    </div>
  </div>
</section> -->

<!-- -------------------------Strength End----------------- -->

<!-- -------------------------Vision Start----------------- -->
<!-- <section id="abt_intro">
  <div class="container">
    <h2 class="vision_mission">Our Vision & Mission</h2>
    <div class="row intro_holder">
      <div class="col-lg-6 col-12">
        <div class="service_item vision animate__animated show-on-scroll animate__bounceIn coloured p-5">
          <h2 class="ab_sec_heading  text-center">Vision</h2>
          <p class="text-center">
            To empower businesses and individuals through innovative technology
            solutions, fostering resilience and growth in an ever-evolving
            digital landscape. We envision a future where technology seamlessly
            integrates with human ingenuity, enabling organizations to thrive
            and make a meaningful impact.
          </p>
        </div>
      </div>
      <div class="col-lg-6 col-12">
        <div class="service_item animate__animated show-on-scroll animate__bounceIn coloured p-5">
          <h2 class="ab_sec_heading  text-center">Mission</h2>
          <p class="text-center">
            To design, develop, and deliver exceptional software and web solutions that meet the unique needs of our
            clients, exceeding their expectations and driving their success. We're committed to:
          </p>
          <p class="text-center">Delivering top-notch solutions that meet the highest standards of quality and
            innovation</p> -->
<!-- <p>Building long-lasting relationships with our clients, founded on trust, transparency, and open communication</p> -->
<!-- <p>Fostering a culture of continuous learning, creativity, and collaboration within our team</p>
          <p>Embracing the latest technologies and trends to stay ahead of the curve</p> -->
<!-- </div>
      </div>
    </div>
  </div>
</section> -->

<!-- -------------------------Vision End----------------- -->

<!-- -------------------------Mission  Start----------------- -->
<!-- <section id="abt_intro">
  <div class="container">
    <div class="intro_holder">
      <div class="col-lg-12 col-md-12 col-sm-12">
        <div
          class="animate__animated show-on-scroll animate__bounceIn white p-5"
        >
          <h2 class="ab_sec_heading text-center">Our Mission</h2>
          <div class="row">
            <div class="col-lg-12">
              <p>
                To design, develop, and deliver exceptional software and web
                solutions that meet the unique needs of our clients, exceeding
                their expectations and driving their success. We're committed
                to:
              </p>
            </div>
            <div class="col-lg-3 gx-2 text-center">
              <div class="mission">
                <div class="background-image mission-one-img"></div>
                <div class="overlay"></div>
                <span
                  >Delivering top-notch solutions that meet the highest
                  standards of quality and innovation</span
                >
              </div>
            </div>
            <div class="col-lg-3 gx-2 text-center">
              <div class="mission">
                <div class="background-image mission-two-img"></div>
                <div class="overlay"></div>
                <span
                  >Building long-lasting relationships with our clients, founded
                  on trust, transparency, and open communication</span
                >
              </div>
            </div>

            <div class="col-lg-3 gx-2 text-center">
              <div class="mission">
                <div class="background-image mission-three-img"></div>
                <div class="overlay"></div>
                <span
                  >Fostering a culture of continuous learning, creativity, and
                  collaboration within our team</span
                >
              </div>
            </div>
            <div class="col-lg-3 gx-2 text-center">
              <div class="mission">
                <div class="background-image mission-four-img"></div>
                <div class="overlay"></div>
                <span
                  >Embracing the latest technologies and trends to stay ahead of
                  the curve</span
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section> -->
<!-- -------------------------Mission End----------------- -->
<!-- -------------------------Our Values Start----------------- -->
<app-values></app-values>
<!-- -------------------------Our Values End----------------- -->

<!------------------------What We Do Start----------------------->
<app-services anchor="about-services"></app-services>
<!--------------------------------------What We Do End------------------------------------------->

<!-------------------------------------Our Expertise Start---------------------------------------------->
<app-tech></app-tech>
<!-------------------------------------Our Expertise End---------------------------------------------->

<!-------------------------------------Our Team Start------------------------------------------------------->
<!-- <section id="abt_intro">
  <div class="container">
    <div class="intro_holder">
      <div class="col-lg-12 col-md-12 col-sm-12">
        <div style="padding: 10px" class="animate__animated show-on-scroll animate__bounceIn white p-5">
          <div>
            <h1 class="ab_sec_heading text-center">Our Team</h1>
            <p class="fw-bold text-center">
              Our team of experts includes experienced developers, designers,
              marketers, and project managers who work together to deliver
              exceptional results. We're passionate about what we do and are
              dedicated to helping our clients succeed.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</section> -->

<!-----------------------------------------Our Team End--------------------------------------------------------->

<!-- <p>
        ResilienceSoft is a global business advisory firm that provides
        multidisciplinary solutions to complex challenges and opportunities.
        With the full power of unique depth of thought combined with the global
        expertise of leading professionals, we are committed to protecting and
        enhancing the enterprise value of our clients.
      </p> -->
<!-- <p>
        ResilienceSoft is a leading brand in Web Design and Software Development
        organization. ResilienceSoft doing extensive work in the field of
        Website Designing, Website Development and SEO. Based in the Bilaspur,
        (Chhattisgarh), our Web Development and SEO Company is committed to
        provide work which pushes the limits of creativity and at a quick
        turnaround time. -->
<!-- </p> -->

<!-- -------------------------Intro Section End----------------- -->

<!-- -------------------------Office Section Start----------------- -->
<app-team></app-team>
<!-- -------------------------Office Section End----------------- -->

<!-- -------------------------Team Section Start----------------- -->
<app-leaders [leaders]="experts"></app-leaders>
<!-- -------------------------Team Section End----------------- -->

<!----------------------------Our Customer Start------------------>
<!-- <section id="abt_intro">
  <div class="container">
    <div class="intro_holder">
      <h2 class="ab_sec_heading text-center">Our Clients</h2>
      <p>
        At ResilienceSoft, we take pride in our diverse client base, spanning
        various industries and sectors. Our clients trust us to deliver
        innovative technology solutions that meet their unique needs and drive
        their success. Here are some of our esteemed clients:
      </p>
      <div class="my-2 mx-2 d-flex expertiseList">
        <div class="expertise_option">Healthcare</div>
        <div class="expertise_option">Finance: details of clients</div>
        <div class="expertise_option">Education:</div>
        <div class="expertise_option">Retail:</div>
        <div class="expertise_option">Manufacturing:</div>
        <div class="expertise_option">Government:</div>
        <div class="expertise_option">Social media</div>
      </div>
      <div class="m-t">
        <p class="fw-bold">
          We have helped our clients achieve significant benefits, including:
        </p>
        <p>- Improved efficiency and productivity</p>
        <p>- Enhanced customer experience</p>
        <p>- Increased revenue and growth</p>
        <p>- Better decision-making with data-driven insights</p>
        <p>- Enhanced security and compliance</p>
      </div>
    </div>
  </div>
</section> -->

<!-- .................................................................. -->
<app-reviews [reviews]="clientFeedback"></app-reviews>
<!-- .......................................................................... -->
<app-contact (consult)="openConsultDialog()"></app-contact>

<!-- ........................................................................... -->

<!-- <section>
  <video width="100%" controls autoplay="true">
    <source src="assets/images/video.mp4" type="video/mp4" />
    <source src="assets/images/video.ogg" type="video/ogg" />
  </video>
</section> -->


<!-- -------------------------Video Section Start----------------- -->


<!-- ........................................................................... -->
